var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.customClass }, [
    _vm.cleanConditions && _vm.cleanConditions.length > 0
      ? _c("div", [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.getValueFromCondition) },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.cleanConditions || _vm.cleanConditions.length == 0
      ? _c("div", [_c("span", [_vm._v(" " + _vm._s(_vm.formatValue))])])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }